module.exports = __webpack_public_path__ + "static/img/sign.d520e1cd.png";